<lds-modal #modal [closeButton]="true" [overlay]="true" [size]="Size.LG">
  <div class="h-[70vh] w-full overflow-hidden rounded-xl">
    <google-map
      #modalMap
      [options]="mapOptions()"
      [mapId]="GOOGLE_MAP_ID"
      [width]="'100%'"
      [height]="'100%'"
      (mapInitialized)="onMapInitialized()"
    >
      @if (marker(); as markerOptions) {
        <map-advanced-marker [options]="markerOptions" />
      }
    </google-map>
  </div>
</lds-modal>
